module.exports = __webpack_public_path__ + "img/EM.8118e78f.svg";